import HttpRequestService from "./HttpRequestService";
 
const StudentService = {};
 
const cntrlName = "student";
 const cntrlUserName = "user";

 
//Api for create
StudentService.create = function (data) {
  return HttpRequestService.post(cntrlName, data);
};
//Api for get data by id
StudentService.getById = function (id) {
  return HttpRequestService.get(cntrlName + "/" + id);
};

//Api for update
StudentService.update = function (id, data) {
  return HttpRequestService.put(cntrlName + "/" + id, data);
};
 
StudentService.getBasicDetails = function (data) {
  return HttpRequestService.post(`${cntrlUserName}/GetBasicDetails`, data);
};

StudentService.postSaveincomeDocuments = function (params) {
  const { Email, Documents, DocumentNumber } = params;
  return HttpRequestService.post(
    `${cntrlName}/SaveincomeDocuments?Email=${encodeURIComponent(Email)}&Documents=${encodeURIComponent(Documents)}&DocumentNumber=${encodeURIComponent(DocumentNumber)}`
  );
};

//Api for update
// StudentService.UploadImage = function (data) {
//   return HttpRequestService.post(`UploadImage?folderName=${data?.folderName}`, data);
// };

StudentService.UploadImage = function (body) {
  return HttpRequestService.post(`UploadImage?folderName=uploads`, body,
   {
    headers: { "Content-Type": "multipart/form-data" },
    body: body
  })

  // return HttpRequestService.post(`UploadImage?folderName=${data.get("folderName")}`, data)
//    {
//     headers: { "Content-Type": "multipart/form-data" },
//   }
// );
};
// //Api for post Save income Documents
// WaiverService.postSaveincomeDocuments = function (params) {
//   return HttpRequestService.get(`"cntrlName/SaveincomeDocuments?Email=${params}&Documents=${params}s&DocumentNumber=${params}"`);
// };

StudentService.postWaiveoffApplication = function (data) {
  return HttpRequestService.post(`${cntrlName}/WaiveoffApplication`, data);
};

// StudentService.postWaiveoffStudentSubmit = function (data) {
//   return HttpRequestService.post(`${cntrlName}/submit`, data);
// };
StudentService.postWaiveoffStudentSubmit = function (formData) {
  return HttpRequestService.postFormData(`${cntrlName}/submit`, formData);
};


StudentService.postEvaluateStudentAnswersAsync = function (data) {
  return HttpRequestService.post(
    `${cntrlName}/EvaluateStudentAnswersAsync?Email=${data.Email}&Studentname=${data.Studentname}&ApplicationId=${data.ApplicationId}&ApplicationType=${data.ApplicationType}`,
    data.answers // send only the array in body
  );
};

//API for accept student
StudentService.postStudentAccept = function (body) {
  return HttpRequestService.post(`send-admission-accepted?email=${body.email}&name=${body.name}&grade=${body.grade}`);
};

//API for accept student
StudentService.getStudentQuestion = function (body) {
  return HttpRequestService.get(`/student/Question`);
};


export default StudentService;